import axios from "axios";

export const Headers = {
  multipart: {
    "Content-Type": "multipart/form-data",
  },
};

export const meta = {
  baseURL: process.env.REACT_APP_API_BASE,
};

const instance = axios.create({
  baseURL: meta.baseURL,
  validateStatus: function (status) {
    return status >= 200 && status < 300;
  },
});

export const axiosFetch = {
  get: instance.get,
  post: instance.post,
};

export default instance;
